<section class="relative flex flex-col items-center w-full">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2">
    <header>
      <h1 class="font-display text-2xl md:text-3xl font-bold text-gray-900">Notifications</h1>
      <p class="text-gray-500 mt-1">Récupérations automatiques de documents pour vos clients.</p>
    </header>

    <article class="rounded-xl border border-gray-200 bg-white shadow-sm">
      @if (loading()) {
        <p class="p-5 text-sm text-gray-500">Chargement...</p>
      } @else if (!notifications().length) {
        <div class="p-8 flex flex-col items-center justify-center text-center gap-4">
          <div class="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center">
            <span class="material-symbols-outlined text-gray-500">notifications</span>
          </div>
          <div>
            <p class="font-semibold text-gray-900">Aucune notification</p>
            <p class="text-sm text-gray-500 mt-1">
              Vous serez notifié lors des récupérations automatiques (succès ou échec).
            </p>
          </div>
        </div>
      } @else {
        <ul class="divide-y divide-gray-100">
          @for (notification of notifications(); track notification.id) {
            <li class="p-4 flex items-start justify-between gap-4">
              <div class="min-w-0 flex-1">
                <div class="flex flex-wrap items-center gap-2 mb-1">
                  <span
                    class="text-xs px-2 py-0.5 rounded font-medium"
                    [class]="notification.success ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
                  >
                    {{ notification.success ? 'Succès' : 'Échec' }}
                  </span>
                  <span class="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600">
                    {{ documentTypeLabel(notification.documentType) }}
                  </span>
                </div>
                <p class="font-medium text-gray-900">{{ notification.title }}</p>
                @if (notification.companyName || notification.siret) {
                  <p class="text-xs text-gray-500 mt-1">
                    {{ notification.companyName || 'Entreprise' }}
                    @if (notification.siret) {
                      <span> · {{ notification.siret }}</span>
                    }
                  </p>
                }
                @if (notification.description) {
                  <p class="text-sm text-gray-600 mt-1">{{ notification.description }}</p>
                }
                <p class="text-xs text-gray-500 mt-2">{{ notification.createdAt | date: 'dd/MM/yyyy HH:mm' }}</p>
              </div>
              @if (!notification.read) {
                <button
                  class="shrink-0 rounded-md border border-secondary/25 bg-secondary/10 px-3 py-1.5 text-xs font-medium text-secondary hover:bg-secondary/15 cursor-pointer"
                  (click)="markAsRead(notification)"
                >
                  Marquer lu
                </button>
              }
            </li>
          }
        </ul>
      }
    </article>
  </div>
</section>


